exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-template-select-container-2e3EG{width:100%;height:100%;overflow-y:auto;display:flex;flex-wrap:wrap;justify-content:flex-start;align-content:flex-start}.index-template-detail-list-container-ZJzhb{width:100%;box-sizing:content-box;padding:16px 8px 0 16px;height:539px;overflow-y:scroll}", ""]);

// Exports
exports.locals = {
	"template-select-container": "index-template-select-container-2e3EG",
	"template-detail-list-container": "index-template-detail-list-container-ZJzhb"
};